module.exports = __webpack_public_path__ + "img/kurand_ec_partner_bnr1.5a497c39.png";